import { render } from "./data-maintain-person.vue?vue&type=template&id=73393d5b&scoped=true"
import script from "./data-maintain-person.vue?vue&type=script&lang=js"
export * from "./data-maintain-person.vue?vue&type=script&lang=js"

import "./data-maintain-person.vue?vue&type=style&index=0&id=73393d5b&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73393d5b"]])

export default __exports__